export type ActionTypes = {
    CLEAR: string,
    SELECT: string,

    GET: string,
    GET_SUCCESS: string,
    GET_FAILED: string,
    LIST_FIRST_TIME: string,
    LIST: string,
    LIST_SUCCESS: string,
    LIST_FAILED: string,
    CREATE: string,
    CREATE_SUCCESS: string,
    CREATE_FAILED: string,
    UPDATE: string,
    UPDATE_SUCCESS: string,
    UPDATE_FAILED: string,
    DELETE: string,
    DELETE_SUCCESS: string,
    DELETE_FAILED: string,

    SHOW: string,
    SHOW_SUCCESS: string,
    SHOW_FAILED: string,

    EXPORT: string,
    EXPORT_SUCCESS: string,
    EXPORT_FAILED: string,

    EXPORT_BIG_DATA: string,
    EXPORT_BIG_DATA_SUCCESS: string,
    EXPORT_BIG_DATA_FAILED: string,

    DOWNLOAD_FROM_URL: string,
    DOWNLOAD_FROM_URL_SUCCESS: string,
    DOWNLOAD_FROM_URL_FAILED: string,

    EXPORT_DETAIL: string,
    EXPORT_DETAIL_SUCCESS: string,
    EXPORT_DETAIL_FAILED: string,

    UPLOAD: string,
    UPLOAD_SUCCESS: string,
    UPLOAD_FAILED: string,
    DOWNLOAD_TEMPLATE: string,
    DOWNLOAD_TEMPLATE_SUCCESS: string,
    DOWNLOAD_TEMPLATE_FAILED: string,
};

export function createActionTypes(entity): ActionTypes {
    const entityName = normalizeEntityName(entity.toUpperCase());

    const ACTIONS = {
        CLEAR: 'clear',
        SELECT: 'select',
        GET: 'get',
        LIST_FIRST_TIME: 'list_first_time',
        LIST: 'list',
        CREATE: 'create',
        UPDATE: 'update',
        DELETE: 'delete',
        SHOW: 'show',
        EXPORT: 'export',
        EXPORT_BIG_DATA: 'export_big_data',
        DOWNLOAD_FROM_URL: 'download_from_url',
        EXPORT_DETAIL: 'export_detail',
        UPLOAD: 'upload',
        DOWNLOAD_TEMPLATE: 'download',
    };

    const STATUS = {
        SUCCESS: 'success',
        FAILED: 'failed',
    };

    function createType(action, status) {
        if (status) {
            return `${action.toUpperCase()}_${entityName}_${status.toUpperCase()}`;
        }
        return `${action.toUpperCase()}_${entityName}`;
    }

    function normalizeEntityName(name) {
        if (name) {
            return name.replace(/-/g, '_').replace(/\//g, '_')
        }
    }

    const CLEAR = createType(ACTIONS.CLEAR);
    const SELECT = createType(ACTIONS.SELECT);
    const GET = createType(ACTIONS.GET);
    const GET_SUCCESS = createType(ACTIONS.GET, STATUS.SUCCESS);
    const GET_FAILED = createType(ACTIONS.GET, STATUS.FAILED);
    const LIST_FIRST_TIME = createType(ACTIONS.LIST_FIRST_TIME);
    const LIST = createType(ACTIONS.LIST);
    const LIST_SUCCESS = createType(ACTIONS.LIST, STATUS.SUCCESS);
    const LIST_FAILED = createType(ACTIONS.LIST, STATUS.FAILED);
    const CREATE = createType(ACTIONS.CREATE);
    const CREATE_SUCCESS = createType(ACTIONS.CREATE, STATUS.SUCCESS);
    const CREATE_FAILED = createType(ACTIONS.CREATE, STATUS.FAILED);
    const UPDATE = createType(ACTIONS.UPDATE);
    const UPDATE_SUCCESS = createType(ACTIONS.UPDATE, STATUS.SUCCESS);
    const UPDATE_FAILED = createType(ACTIONS.UPDATE, STATUS.FAILED);
    const DELETE = createType(ACTIONS.DELETE);
    const DELETE_SUCCESS = createType(ACTIONS.DELETE, STATUS.SUCCESS);
    const DELETE_FAILED = createType(ACTIONS.DELETE, STATUS.FAILED);

    const SHOW = createType(ACTIONS.SHOW);
    const SHOW_SUCCESS = createType(ACTIONS.SHOW, STATUS.SUCCESS);
    const SHOW_FAILED = createType(ACTIONS.SHOW, STATUS.FAILED);

    const EXPORT = createType(ACTIONS.EXPORT);
    const EXPORT_SUCCESS = createType(ACTIONS.EXPORT, STATUS.SUCCESS);
    const EXPORT_FAILED = createType(ACTIONS.EXPORT, STATUS.FAILED);

    const EXPORT_BIG_DATA = createType(ACTIONS.EXPORT_BIG_DATA);
    const EXPORT_BIG_DATA_SUCCESS = createType(ACTIONS.EXPORT_BIG_DATA, STATUS.SUCCESS);
    const EXPORT_BIG_DATA_FAILED = createType(ACTIONS.EXPORT_BIG_DATA, STATUS.FAILED);

    const DOWNLOAD_FROM_URL = createType(ACTIONS.DOWNLOAD_FROM_URL);
    const DOWNLOAD_FROM_URL_SUCCESS = createType(ACTIONS.DOWNLOAD_FROM_URL, STATUS.SUCCESS);
    const DOWNLOAD_FROM_URL_FAILED = createType(ACTIONS.DOWNLOAD_FROM_URL, STATUS.FAILED);

    const EXPORT_DETAIL = createType(ACTIONS.EXPORT_DETAIL);
    const EXPORT_DETAIL_SUCCESS = createType(ACTIONS.EXPORT_DETAIL, STATUS.SUCCESS);
    const EXPORT_DETAIL_FAILED = createType(ACTIONS.EXPORT_DETAIL, STATUS.FAILED);

    const UPLOAD = createType(ACTIONS.UPLOAD);
    const UPLOAD_SUCCESS = createType(ACTIONS.UPLOAD, STATUS.SUCCESS);
    const UPLOAD_FAILED = createType(ACTIONS.UPLOAD, STATUS.FAILED);

    const DOWNLOAD_TEMPLATE = createType(ACTIONS.DOWNLOAD_TEMPLATE);
    const DOWNLOAD_TEMPLATE_SUCCESS = createType(ACTIONS.DOWNLOAD_TEMPLATE, STATUS.SUCCESS);
    const DOWNLOAD_TEMPLATE_FAILED = createType(ACTIONS.DOWNLOAD_TEMPLATE, STATUS.FAILED);

    return {
        CLEAR, SELECT,
        GET, GET_SUCCESS, GET_FAILED,
        LIST_FIRST_TIME, LIST, LIST_SUCCESS, LIST_FAILED,
        CREATE, CREATE_SUCCESS, CREATE_FAILED,
        UPDATE, UPDATE_SUCCESS, UPDATE_FAILED,
        DELETE, DELETE_SUCCESS, DELETE_FAILED,
        SHOW, SHOW_SUCCESS, SHOW_FAILED,
        EXPORT, EXPORT_SUCCESS, EXPORT_FAILED,
        EXPORT_BIG_DATA, EXPORT_BIG_DATA_SUCCESS, EXPORT_BIG_DATA_FAILED,
        DOWNLOAD_FROM_URL, DOWNLOAD_FROM_URL_SUCCESS, DOWNLOAD_FROM_URL_FAILED,
        EXPORT_DETAIL, EXPORT_DETAIL_SUCCESS, EXPORT_DETAIL_FAILED,
        UPLOAD, UPLOAD_SUCCESS, UPLOAD_FAILED,
        DOWNLOAD_TEMPLATE, DOWNLOAD_TEMPLATE_SUCCESS, DOWNLOAD_TEMPLATE_FAILED,
    };
}
